module.exports = __webpack_public_path__ + "static/media/industrialIcon.111b4e8c.svg";